import request from '@/utils/request'

let AdvanceApi = {
  /*商品列表*/
  productList(data, errorback) {
    return request._post('/supplier/activity.advance/index', data, errorback);
  },
  /*添加商品*/
  getProduct(data, errorback) {
    return request._get('/supplier/activity.advance/add', data, errorback);
  },
  /*添加商品*/
  addProduct(data, errorback) {
    return request._post('/supplier/activity.advance/add', data, errorback);
  },
  /*预售商品详情*/
  detail(data, errorback) {
    return request._get('/supplier/activity.advance/edit', data, errorback);
  },
  /*保存预售商品*/
  saveData(data, errorback) {
    return request._post('/supplier/activity.advance/edit', data, errorback);
  },
  delProduct(data, errorback) {
    return request._post('/supplier/activity.advance/delete', data, errorback);
  },
  /*获取设置*/
  getDiySkill(data, errorback) {
    return request._post('/supplier/activity.advance/getDiyProduct', data, errorback);
  },
}
export default AdvanceApi;



// WEBPACK FOOTER //
// ./src/api/advance.js